import { env } from '@/core/config/env';
import { registerLicense } from '@syncfusion/ej2-base';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initializeApp } from '@/app/bootstrap';
import { RootErrorBoundary } from '@/core/error-boundaries/public';
import { initSentry, sentryReporter } from '@/core/observability/public';
import { AppProviders } from './app/providers.tsx';
import App from './App.tsx';

import 'sileo/styles.css';
import './index.css';
import { TooltipProvider } from './shared/components/ui/tooltip.tsx';

// Syncfusion Gantt license. Empty key = trial mode (watermark) — see .env.example.
// Must run before the first render; registering an empty string is a no-op, so guard it.
if (env.VITE_SYNCFUSION_LICENSE_KEY) {
  registerLicense(env.VITE_SYNCFUSION_LICENSE_KEY);
}

initializeApp();
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootErrorBoundary reporter={sentryReporter}>
      <AppProviders>
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </AppProviders>
    </RootErrorBoundary>
  </StrictMode>,
);
